export default {
  "default-old": () => import("/var/www/html/layouts/default-old.vue").then(m => m.default || m),
  default: () => import("/var/www/html/layouts/default.vue").then(m => m.default || m),
  "editor-eraser": () => import("/var/www/html/layouts/editor-eraser.vue").then(m => m.default || m),
  "editor-old": () => import("/var/www/html/layouts/editor-old.vue").then(m => m.default || m),
  editor: () => import("/var/www/html/layouts/editor.vue").then(m => m.default || m),
  "mobile-video": () => import("/var/www/html/layouts/mobile-video.vue").then(m => m.default || m),
  "select-design-old": () => import("/var/www/html/layouts/select-design-old.vue").then(m => m.default || m),
  "select-design": () => import("/var/www/html/layouts/select-design.vue").then(m => m.default || m)
}